import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { TourId } from 'webapp/enums/tour';

import type ReportsPagelessAddBlocksTour from 'webapp/models-custom/tour/reports/pageless-add-blocks';
import type ReportsPagelessAddColumnTour from 'webapp/models-custom/tour/reports/pageless-add-column';
import type ReportsPagelessCustomizeTour from 'webapp/models-custom/tour/reports/pageless-customize';
import type ReportsPagelessShareTour from 'webapp/models-custom/tour/reports/pageless-share';
import type ReportsPagelessViewSwitchTour from 'webapp/models-custom/tour/reports/pageless-view-switch';

import FlowTourBaseService from 'webapp/services/flow/tour/base';

export type PagelessTour =
	| ReportsPagelessAddBlocksTour
	| ReportsPagelessAddColumnTour
	| ReportsPagelessCustomizeTour
	| ReportsPagelessShareTour
	| ReportsPagelessViewSwitchTour;

export interface PagelessTourSettings {
	id: TourId;
	checkStartConditions: () => boolean;
}

export default class FlowTourReportsPagelessService extends FlowTourBaseService {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('popup') declare popupService: Service.Popup;

	@cached
	get orderedTourIds(): TourId[] {
		return [
			TourId.REPORTS__PAGELESS_ADD_BLOCKS,
			TourId.REPORTS__PAGELESS_ADD_COLUMN,
			TourId.REPORTS__PAGELESS_CUSTOMIZE,
			TourId.REPORTS__PAGELESS_SHARE,
			TourId.REPORTS__PAGELESS_VIEW_SWITCH,
		];
	}

	override checkGeneralEligibility(): boolean {
		const routePath = String(this.navigationService.activatedRoute);
		return (
			super.checkGeneralEligibility() &&
			routePath.includes('reports') &&
			this.currentUserService.deviceString === 'desktop'
		);
	}
}

declare module '@ember/service' {
	interface Registry {
		'flow/tour/reports-pageless': FlowTourReportsPagelessService;
	}
}
